import request from '@/router/axios';

export const add = (row) => {
  return request({
    url: '/api/produce/wagon-tippler-operation-phase-detail/insert',
    method: 'post',
    data: row
  })
}
export const update = (row) => {
  return request({
    url: '/api/produce/wagon-tippler-operation-phase-detail/update',
    method: 'post',
    data: row
  })
}
export const getDetail = (id) => {
  return request({
    url: '/api/produce/wagon-tippler-operation-phase-detail/selectId',
    method: 'get',
    params: {
      id
    }
  })
}
export const getList = (params) => {
  return request({
    url: '/api/produce/wagon-tippler-operation-phase-detail/selectPage',
    method: 'get',
    params
  })
}
export const remove = (ids) => {
  return request({
    url: '/api/produce/wagon-tippler-operation-phase-detail/deleteIds',
    method: 'get',
    params: {
      ids
    }
  })
}

export const getWagonTipplerOperationRecordPage = (params) => {
  return request({
    url: '/api/produce/wagon-tippler-operation-record/selectPage',
    method: 'post',
    params
  })
}

